import React from 'react'
import type { GatsbyBrowser } from 'gatsby'
import { GlobalStyle } from './src/styles/globalstyle'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
    return (
        <>
            <GlobalStyle />
            {element}
        </>
    )
}

export const onInitialClientRender = () => {
    if (typeof window !== "undefined") {
        const w = window as any; // <--- to kluczowe

        window.addEventListener("scroll", () => {
            const scrollDepth = Math.floor(
                ((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100
            );

          if (scrollDepth >= 25 && !w.scroll25) {
              w.scroll25 = true;
              w.gtag?.("event", "scroll_depth", {
                  percent_scrolled: 25,
              });
          }
          if (scrollDepth >= 50 && !w.scroll50) {
              w.scroll50 = true;
              w.gtag?.("event", "scroll_depth", {
                  percent_scrolled: 50,
              });
          }
          if (scrollDepth >= 75 && !w.scroll75) {
              w.scroll75 = true;
              w.gtag?.("event", "scroll_depth", {
                  percent_scrolled: 75,
              });
          }
          if (scrollDepth >= 90 && !w.scroll90) {
              w.scroll90 = true;
              w.gtag?.("event", "scroll_depth", {
                  percent_scrolled: 90,
              });
          }
      });
    }
};

